"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _colorManipulator = require("@material-ui/core/styles/colorManipulator");

var _makeStyles = _interopRequireDefault(require("@material-ui/styles/makeStyles"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var styles = (0, _makeStyles.default)(function (theme) {
  var _theme$palette, _theme$palette$primar, _theme$palette2, _theme$palette2$prima;

  return {
    register: _defineProperty({
      display: "flex",
      flexDirection: "column"
    }, theme.breakpoints.up("md"), {
      background: (0, _colorManipulator.alpha)((_theme$palette = theme.palette) === null || _theme$palette === void 0 ? void 0 : (_theme$palette$primar = _theme$palette.primary) === null || _theme$palette$primar === void 0 ? void 0 : _theme$palette$primar.main, 0.05),
      padding: theme.spacing(4)
    }),
    headline: {
      color: (_theme$palette2 = theme.palette) === null || _theme$palette2 === void 0 ? void 0 : (_theme$palette2$prima = _theme$palette2.primary) === null || _theme$palette2$prima === void 0 ? void 0 : _theme$palette2$prima.main,
      fontSize: "2rem",
      fontWeight: theme.typography.fontWeightBold,
      marginBottom: theme.spacing(2)
    },
    buttons: _defineProperty({
      display: "flex",
      flexDirection: "column",
      gap: theme.spacing(2),
      justifyContent: "flex-end",
      marginTop: "auto",
      paddingTop: theme.spacing(4)
    }, theme.breakpoints.up("md"), {
      flexDirection: "row"
    })
  };
});
var _default = styles;
exports.default = _default;